export default "__VITE_ASSET__BE9Sr9RC__"